import React, { Fragment, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DataTable from 'react-data-table-component';
import { Link } from 'react-router-dom';

import { editarBreadcrumb } from '../../../actions/breadcrumb';
import { buscarNivelesConfiguracion } from '../../../actions/configuracion';

import NuevoNivel from './NuevoNivel';
import EditarNivel from './EditarNivel';
import EliminarNivel from './EliminarNivel';

const Niveles = () => {

    let rutasBread = [
        {
            activo: true,
            nombre: 'Niveles educativos',
            path: '/configuracion/educacion'
        }
    ];

    const dispatch =  useDispatch();

    const { listado } = useSelector(state => state.configuracion.educacion);

    const [niveles, setNiveles] = useState([]);

    const [nivelAgregar, setNivelAgregar] = useState(null);
    const [nivelEditar, setNivelEditar] = useState(null);
    const [nivelEliminar, setNivelEliminar] = useState(null);

    const paginationOptions = { rowsPerPageText: 'Filas por página', rangeSeparatorText: 'de' };

    const columns = [
        {
            name: 'Orden',
            sortable: true, 
            cell: item => `${item.orden ? item.orden : ' - '}`
        },
        {
            name: 'Nombre',
            sortable: true, 
            selector: row => row.nombre,
        },
        {
            name: 'Jovenes relacionados',
            sortable: true, 
            selector: row => row.jovenes,
        },
        {
            name: 'Instituciones',
            sortable: true, 
            selector: row => row.instituciones,
        },
        {
            name: '',
            cell: row => {
                if(row._id){
                    return(
                        <div className="text-right w-100">
                            <button type="button" className="btn btn-sm btn-link px-2 float-end" onClick={() => handleEliminarNivel(row)}><i className="fas fa-trash text-danger"></i></button>
                            <button type="button" className="btn btn-sm btn-link px-2 float-end" onClick={() => handleEditarNivel(row)}><i className="fas fa-edit text-warning"></i></button>
                            <Link className="btn btn-sm btn-link px-2 float-end" to={`/configuracion/educacion/instituciones/${row._id}`}><i className="fas fa-building-columns text-info"></i></Link>
                        </div>
                    )
                }else{
                    return(<></>)
                }
            }
        }
    ];

    /* Crear nivel */
    const handleAgregarNivel = (nivel) => {
        setNivelEditar(null);
        setNivelEliminar(null);

        setNivelAgregar(nivel);        
    }

    /* Editar nivel */
    const handleEditarNivel = (nivel) => {
        setNivelAgregar(null);
        setNivelEliminar(null);

        setNivelEditar(nivel);
    }

    /* Eliminar nivel */
    const handleEliminarNivel = (nivel) => {
        setNivelAgregar(null);
        setNivelEditar(null);

        setNivelEliminar(nivel);
    }

    useEffect(() => {
        dispatch(buscarNivelesConfiguracion());
    }, []);

    useEffect(() => {
        setNiveles(listado);
    }, [listado]);

    useEffect(() => {
        dispatch(editarBreadcrumb(rutasBread));
    }, [rutasBread]);

    return (
        <Fragment>

            <NuevoNivel nivel={nivelAgregar} reestablecerNivel={handleAgregarNivel} />
            <EditarNivel nivel={nivelEditar} reestablecerNivel={handleEditarNivel} />
            <EliminarNivel nivel={nivelEliminar} reestablecerNivel={handleEliminarNivel} />

            <div className="row">
                <div className="col-md-10 offset-md-1 pb-4">
                    <h3 className="mb-3 mt-5">Niveles educativos</h3>

                    <div className="d-flex justify-content-end">
                        <button type="button" className="btn btn-primary" onClick={() => handleAgregarNivel({ })}>Agregar nivel</button>
                    </div>

                    <div className="mt-2">
                        <DataTable 
                            columns={columns}
                            data={niveles}
                            pagination
                            paginationPerPage={20}
                            paginationRowsPerPageOptions={[5, 10, 20, 50]}
                            paginationComponentOptions={paginationOptions}
                            highlightOnHover={true}
                        />
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default Niveles;